import script from "./invoice-offline-dialog-content.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-offline-dialog-content.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__